/**
 * 远程设备概览面板组件。
 */
import { useSessionStore, useWebRTCStore } from "@/stores/remote";
import winPaper from "./windows_wallpaper.jpg";

/**
 * 展示远程设备基础信息。
 *
 * connectionState 取 useWebRTCStore（由 RTCPeerConnection 实时驱动）；
 * 早期版本读 useDeviceStore 的同名字段，但没人调用 updateConnectionState，
 * 结果永远停留在 "new"。
 */
const DeviceOverview = () => {
	const connectionState =
		useWebRTCStore((state) => state.connectionState) ?? "new";
	const deviceInfo = useSessionStore((state) => state.deviceInfo);
	const sessionInfo = useSessionStore((state) => state.sessionInfo);

	return (
		<div className="overflow-hidden text-sm transition-height duration-200 linear rounded bg-gray-200 p-2.5">
			<div className="flex">
				<div className="mx-6 my-4">
					<img
						className="max-w-[320px]"
						src={winPaper}
						alt="Device Wallpaper"
					/>
				</div>
				<div className="mx-2 grow">
					<div className="mb-4">
						<span className="font-bold block mb-2">
							Device info: {connectionState}
						</span>

						<div>Host Name: {deviceInfo?.host_name}</div>
						<div>Platform: {deviceInfo?.platform}</div>
						<div>Platform Version: {deviceInfo?.platform_version}</div>
						<div>Resolution: {deviceInfo?.resolution}</div>
					</div>

					<div>
						<span className="font-bold block mb-2">Network status</span>
						<p className="mb-1">IP Address: {sessionInfo?.ipv4}</p>
						<p className="mb-1">
							Location: {sessionInfo?.city} {sessionInfo?.country}
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default DeviceOverview;
